import React, { useContext, useEffect } from "react";
import _ from "lodash";

// Material-UI
import Avatar from "@material-ui/core/Avatar";
import Chip from "@material-ui/core/Chip";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, alpha } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FolderSharedIcon from "@material-ui/icons/FolderShared";

// Components
import CustomIcon from "@Components/CustomIcon";
import CustomTooltip from "@Components/CustomTooltip";
import { ModuleWrapperContext } from "@Components/ModuleWrapper/ModuleWrapperContext";
import { LdapContext } from "@Modules/ldap/context/ldapContext";

// Styles
import { moduleListing } from "@Styles/ModuleListing";
import theme from "@Styles/theme";

// Internal
import Language from "sccLanguage";
import AdminDevice from "sccAdminDevice";
import AdminDeviceDetail from "./AdminDeviceDetail";

const useStyles = makeStyles((theme) => ({
  ...moduleListing(theme),
  adListItem: {
    ...moduleListing(theme).listItem,
    // backgroundColor: alpha(theme.palette.colors.gray.veryDark, 0.5),
  },
}));

export default function AdminDeviceList(props) {
  const data = props.data;
  const [mwState, setMwState] = useContext(ModuleWrapperContext);
  const { isLdapLoggedIn } = useContext(LdapContext);

  const handleClick = props.handleClick;
  const openDetailsFor = props.openDetailsFor;
  const handleEdit = mwState.handleItemEdit;
  const handleItemDelete = mwState.handleItemDelete;

  const adminUserName = AdminDevice.getDeviceType(data.type_id).title;

  useEffect(() => {
    setMwState((p) => ({
      ...p,
      moduleItemData: { ...p.moduleItemData },
    }));
  }, []);

  const classes = useStyles();

  // check for ldap
  const isAd = (device) => {
    return Boolean(device?.external_management_identification);
  };

  return (
    <React.Fragment>
      <ListItem
        className={isAd(data) ? classes.adListItem : classes.listItem}
        key={data.id}
        onClick={() => handleClick(data.id)}
      >
        <ListItemIcon className={classes.itemIcon}>
          <CustomTooltip title={data.company} placement="left">
            <span>
              <CustomIcon id={`icon-${mwState.icon}`} fontSize="small" />
            </span>
          </CustomTooltip>
        </ListItemIcon>
        <ListItemText
          id={data.id}
          className={classes.itemPrimaryText}
          primary={
            <React.Fragment>
              <span>{data.name + " "}</span>
              {adminUserName ? (
                <Chip
                  size="small"
                  avatar={<Avatar>{adminUserName.charAt(0)}</Avatar>}
                  color={data.active ? "primary" : "default"}
                  label={adminUserName}
                />
              ) : null}
              {isAd(data) && (
                <CustomTooltip
                  title={Language.translate(
                    "This device is managed by external system"
                  )}
                  arrow
                  placement="top"
                >
                  <FolderSharedIcon
                    fontSize="small"
                    style={{
                      verticalAlign: "middle",
                      color: theme.palette.colors.primary.main,
                      paddingLeft: 8,
                    }}
                  />
                </CustomTooltip>
              )}
            </React.Fragment>
          }
        />

        {!isLdapLoggedIn && isAd(data) ? null : (
          <ListItemSecondaryAction
            className={classes.itemActionButtonsContainer}
          >
            {data.role_id !== 2 ? (
              <React.Fragment>
                {mwState.verifyEditPermission && (
                  <CustomTooltip
                    title={Language.translate("Edit")}
                    placement="top"
                  >
                    <IconButton
                      edge="end"
                      aria-label="edit"
                      onClick={() => handleEdit(data)}
                    >
                      <EditIcon />
                    </IconButton>
                  </CustomTooltip>
                )}
                {mwState.verifyDeletePermission && (
                  <CustomTooltip
                    title={Language.translate("Delete")}
                    placement="top"
                  >
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      disabled={mwState.isSaveInProgress}
                      onClick={() =>
                        handleItemDelete(
                          `${mwState.routeUrl}/${data.id}`,
                          mwState.title,
                          "Admin Device",
                          data.name,
                          data.id
                        )
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  </CustomTooltip>
                )}
              </React.Fragment>
            ) : null}
          </ListItemSecondaryAction>
        )}
      </ListItem>
      <Collapse in={openDetailsFor === data.id} timeout="auto" unmountOnExit>
        <AdminDeviceDetail data={data} />
      </Collapse>
    </React.Fragment>
  );
}
